import { render, staticRenderFns } from "./results_PVGIS.vue?vue&type=template&id=22715f48&scoped=true"
import script from "./results_PVGIS.vue?vue&type=script&lang=js"
export * from "./results_PVGIS.vue?vue&type=script&lang=js"
import style0 from "./results_PVGIS.vue?vue&type=style&index=0&id=22715f48&prod&scoped=true&lang=css"
import style1 from "./results_PVGIS.vue?vue&type=style&index=1&id=22715f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22715f48",
  null
  
)

export default component.exports